import api from "@/api";
import _ from "lodash";

const TODAY = "today"
const LAST7DAYS = "last7days"
const ALL_TIME = "all"
const CUSTOM = "custom"

export default {
    TODAY: TODAY,
    LAST7DAYS: LAST7DAYS,
    ALL_TIME: ALL_TIME,
    CUSTOM: CUSTOM,

    namespaced: true,

    actions: {
        async getServiceLogs(context, data) {
            const guid = context.rootGetters['auth/getOrgUid']
            const url = `/admin/organizations/${guid}/serviceLogs`
            let body = data
            const response = await api.request("post", url, body);
            return response.data
        },
    }
}